import React from 'react';
import { convertirMonto, formatMonedaSimbolo } from '../../libs/moneda';
import type { CategoryPrices } from '../../libs/publicPricesSnapshot';
import type { Currency } from './CurrencyToggle';
import '../landing/brand.css';

const ORDEN = ['terneros', 'terneras', 'novillos', 'vaquillonas', 'vacas', 'toros', 'M.E.J'];
// Promedios mensuales de REMATES de la provincia (en la UI no se nombra la fuente). La clave 'novillos'
// guarda los "Novillitos" de invernada (así los carga get-cattle-prices): se
// muestran con su nombre real.
const LABEL: Record<string, string> = {
  terneros: 'Terneros',
  terneras: 'Terneras',
  novillos: 'Novillitos (invernada)',
  vaquillonas: 'Vaquillonas (invernada)',
  vacas: 'Vacas',
  toros: 'Toros',
  'M.E.J': 'MEJ (macho entero joven)',
};

const UNIT: Record<Currency, string> = { ARS: '$/kg', USD: 'u$/kg', constante: 'c$/kg' };

/**
 * Tabla de precios del último mes por categoría (promedio por kg).
 * Convierte a USD/constante según `currency`. Estilo del manual de marca (brand.css).
 */
const PreciosTable: React.FC<{
  latest: Record<string, CategoryPrices>;
  currency: Currency;
  usdRate: number | null;
  uvaToday?: number | null;
  uvaLatestMonth?: number | null;
}> = ({ latest, currency, usdRate, uvaToday = null, uvaLatestMonth = null }) => {
  const filas = ORDEN.filter((c) => latest[c]?.perkg).map((c) => {
    const ranges = Object.entries(latest[c].perkg!);
    const avg = ranges.map(([, p]) => p.average).filter((a) => a > 0);
    const prom = avg.length ? avg.reduce((s, v) => s + v, 0) / avg.length : 0;
    return { cat: c, label: LABEL[c] ?? c, prom };
  });

  if (filas.length === 0) {
    return <p className="lp-note">Sin precios disponibles para mostrar.</p>;
  }

  return (
    <table className="lp-scope lp-prices">
      <thead>
        <tr>
          <th scope="col">Categoría</th>
          <th scope="col">Promedio {UNIT[currency]}</th>
        </tr>
      </thead>
      <tbody>
        {filas.map((f) => (
          <tr key={f.cat}>
            <td>{f.label}</td>
            <td>{formatMonedaSimbolo(convertirMonto(f.prom, currency, usdRate, uvaToday, uvaLatestMonth), currency)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default PreciosTable;
